module.exports = __webpack_public_path__ + "node_modules/icheck/skins/polaris/polaris@2x.png?78fe5012";